import styled from "styled-components";
import { Row, Input, Button, Col } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

// common
import * as Layout from "common/layout";
import { H3 } from "common/text";
import { SectionButton } from "common/button";

const { TextArea } = Input;
const { Section } = Layout;

export const CustomSection = styled(Section)`
  font-size: 16px;
  color: #282828;
`;

export const SectionHeader = styled(H3)`
  margin-bottom: 16px;
  font-weight: bold;
`;

export const CustomSectionButton = styled(SectionButton)``;

export const CustomRow = styled(Row)`
  padding-top: 17px;
  padding-bottom: 15px;
  border-top: 2px solid #282828;
  &:last-child {
    border-bottom: 2px solid #282828;
  }
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: bold;
`;

export const PaymentMethodContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  font-weight: bold;
`;

export const CardNumber = styled.span`
  letter-spacing: 2px;
  margin-left: 4px;
  font-weight: bold;
`;

export const DefaultTag = styled.div`
  font-weight: bold;
  background-color: #1070b6;
  height: 20px;
  font-size: 9px;
  padding: 1px 8px;
  color: white;
  display: flex;
  align-items: center;
  margin-bottom: 1px;
  margin-left: 16px;
`;

export const RemoveButton = styled(FontAwesomeIcon)`
  color: #1070b6;
  margin-bottom: 2px;
  cursor: pointer;

  &:hover {
    opacity: 0.8;
  }
`;

export const SectionText = styled.div`
  color: #282828;
  font-weight: normal;
  margin-bottom: 12px;
`;

export const BillingAddress = styled(TextArea)`
  padding: 16px;
  background-color: #f6f6f6;
  margin: 10px 0px;
  font-size: 16px;
  color: black;

  &::placeholder {
    color: rgba(0, 0, 0, 0.5);
  }
`;

export const DownloadButton = styled(Button)`
  font-size: 18px;
  color: #1070b6;
  letter-spacing: 0.45px;
  font-weight: bold;
  padding: 0px;

  & svg {
    margin-right: 8px;
  }
`;

export const DownloadButtonContainer = styled(Col)`
  display: flex;
  justify-content: flex-end;
`;
